import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-x', 'LetterX', [["path",{"d":"m8 7 7.5 10M8 17l7.5-10","key":"svg-0"}]]);